import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { useStyletron } from 'styletron-react'
import { useDispatch, useSelector } from 'react-redux'
import { selectConfig, selectContactComments } from '../../../SubscriptionForm/SubscriptionFormSelectors'
import { subscriptionFormActionsV2 } from '../../../SubscriptionForm/SubscriptionFormV2Sagas'
import { addCommentToContact } from '../../../SubscriptionForm/SubscriptionFormSlice'

const useComments = () => {
  const { t } = useTranslation()
  const [css] = useStyletron()
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false)
  const [comment, setComment] = useState('')
  const [error, setError] = useState('')
  const [isLoading, setLoading] = useState(false)
  const { contactId } = useSelector(selectConfig)
  const comments = useSelector(selectContactComments)

  const handleResponse = success => {
    setLoading(false)
    if (success && success.success) {
      setComment('')
      dispatch(addCommentToContact(success))
      return
    }
    setError(t('subscriptionTable:save_error'))
  }

  const saveCommentHandler = () => {
    setLoading(true)
    setError('')
    if (comment.length === 0) {
      setError(t('subscriptionTable:mandatory_field'))
      setLoading(false)
      return
    }
    dispatch({
      type: subscriptionFormActionsV2.ADD_COMMENT_TO_CONTACT_V2,
      comment,
      contactId,
      callback: handleResponse,
    })
  }

  return {
    t,
    css,
    comment,
    error,
    isLoading,
    saveCommentHandler,
    setComment,
    isOpen,
    setIsOpen,
    comments,
    dateStyle: css({
      display: 'block',
      width: '100%',
      textAlign: 'right',
      fontSize: '.75rem',
      fontWeight: 'bold',
    }),
    commentsStyle: css({
      fontSize: '.75rem',
      fontStyle: 'italic',
    }),
  }
}

export default useComments
